module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALNJREFUeNpi0MpSmquZoazDgAaY2JmZKpiY/+UC2YwM2IB2pmKzTraSD1wH0KhoEOP/G87m//8Yw7SzlONAfEbtLKVfDP//h1ydfn8TQwNQ4SvFfqD4IyaQLrh5DQz/GRkY/zOB7NPJVIwBiWmFarFpZyku1MpSTmCAuUQrS4uHieHHYiBv7pWp97aAxJg1sjWEmf7/WsnAzNhxdeq9vTBTWYCCXf/+M5Zcn3L3CrLzAQIMAPsbM1lzI4ipAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/hot/listtitle.png
// module id = LyvT
// module chunks = 1